import React from "react";
import { Button, Checkbox, Input, Space } from "antd";
import type { CheckboxChangeEvent } from "antd/es/checkbox";

/**
 * 日志操作组件的属性类型
 */
export interface LogActionsProps {
  /** 已选择的行 Key 列表 */
  selectedRowKeys: React.Key[];
  /** 是否忽略请求间隔 */
  ignoreInterval: boolean;
  /** 回放目标地址 */
  replayTarget: string;
  /** "忽略请求间隔" Checkbox 变化处理函数 */
  onIgnoreIntervalChange: (e: CheckboxChangeEvent) => void;
  /** 回放目标地址变化处理函数 */
  onReplayTargetChange: (value: string) => void;
  /** "重放请求" 按钮点击处理函数 */
  onReplayRequest: () => void;
}

/**
 * 日志操作组件（例如：重放请求）
 * @param {LogActionsProps} props - 组件属性
 * @returns {JSX.Element} React 元素
 */
const LogActions: React.FC<LogActionsProps> = ({
  selectedRowKeys,
  ignoreInterval,
  replayTarget,
  onIgnoreIntervalChange,
  onReplayTargetChange,
  onReplayRequest,
}) => {
  return (
    <Space wrap>
      <Input
        value={replayTarget}
        onChange={(e) => onReplayTargetChange(e.target.value)}
        placeholder="回放目标地址，如 http://test.example.com"
        style={{ width: 360 }}
        allowClear
      />
      <Button
        type="primary"
        onClick={onReplayRequest}
        disabled={selectedRowKeys.length === 0}
      >
        重放请求 ({selectedRowKeys.length})
      </Button>
      <Checkbox checked={ignoreInterval} onChange={onIgnoreIntervalChange}>
        忽略请求间隔
      </Checkbox>
    </Space>
  );
};

export default LogActions;
